export default __webpack_public_path__ + "45b25198a8fed02cdeb69efd25c32286.png";